const AppCrashFallback = () => {
  const handleReload = () => {
    window.location.href = '/';
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center max-w-md px-6">
        <h1 className="text-2xl font-semibold text-gray-800 mb-2">
          Something went wrong
        </h1>
        <p className="text-gray-500 mb-6">
          An unexpected error occurred. Our team has been notified and is looking
          into it.
        </p>
        <button
          onClick={handleReload}
          className="px-5 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default AppCrashFallback;
